import Helper from './Helper';

class Header {
  constructor() {
    let menuItem = document.querySelectorAll('.menu-main__item--level-0.menu-main__item--has-children > a');
    menuItem = Array.prototype.slice.call(menuItem);

    this.menuToggler = document.querySelector('.header__hamburger-button');
    this.menu = document.querySelector('.header__toggle--mobile');

    this.searchToggler = document.querySelectorAll('.header__search-button');
    this.searchBackdrop = document.querySelector('.search-form__background');
    this.search = document.querySelector('.search-form');

    this.languageToggler = document.querySelector('.language-switcher__toggle');


    if (this.menuToggler && this.menu && menuItem) {
      this.bindMenu(menuItem);
      this.bindMobileMenu(this.menuToggler, this.menu);
    }

    if (this.searchToggler && this.searchBackdrop && this.search) {
      this.searchToggler.forEach(toggler => {
        this.bindSearch(toggler, this.search);
      });
      this.bindSearch(this.searchBackdrop, this.search);
    }

    if (this.languageToggler) {
      this.bindLanguage();
    }
  }



  bindMenu(menuItem){
    menuItem.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const subMenu = item.parentNode.querySelector('.menu-main--level-1');
        if(Helper.hasClass(subMenu, 'active')){
          Helper.removeClass(subMenu, 'active');
        } else{
          const toClose = document.querySelector('.menu-main--level-1.active');
          if(toClose){
            Helper.removeClass(toClose, 'active');
          }
          Helper.addClass(subMenu, 'active');
        }
      });
    });
  }

  bindMobileMenu(menuToggler, menu){
    menuToggler.addEventListener('click', (e) => {
      e.preventDefault();
      let body = document.querySelector('body');

      if(Helper.hasClass(menu, 'active')){
        Helper.removeClass(menu, 'active');
      } else{
        this.checkIfTheOtherIsOpen('menu');
        Helper.addClass(menu, 'active');
      }

      if (Helper.hasClass(body, 'menu-open')) {
        Helper.removeClass(body, 'menu-open');
      } else{
        Helper.addClass(body, 'menu-open');
      }
    });
  }

  bindSearch(searchToggler, search){
    searchToggler.addEventListener('click', (e) => {
      e.preventDefault();

      if(Helper.hasClass(search, 'active')){
        Helper.removeClass(search, 'active');
      } else{
        this.checkIfTheOtherIsOpen('search');
        this.bindEsc(search);
        Helper.addClass(search, 'active');
      }

      this.searchToggler.forEach(toggler => {
        if ( Helper.hasClass(toggler, 'active') ) {
          Helper.removeClass(toggler, 'active');
        } else {
          Helper.addClass(toggler, 'active');
        }
      });
    });
  }

  bindLanguage() {
    this.languageToggler.addEventListener('click', (e) => {
      e.preventDefault();

      if ( Helper.hasClass(this.languageToggler, 'active') ) {
        Helper.removeClass(this.languageToggler, 'active');
      } else {
        this.checkIfTheOtherIsOpen('language');
        Helper.addClass(this.languageToggler, 'active');
      }
    });
  }

  checkIfTheOtherIsOpen(entrypoint){
    let body = document.querySelector('body');
    if (Helper.hasClass(body, 'menu-open')) {
      Helper.removeClass(body, 'menu-open');
    }
    
    if(entrypoint === 'search'){
      if(Helper.hasClass(this.menu, 'active')){
        Helper.removeClass(this.menu, 'active');
      }
    } else if(entrypoint === 'menu'){
      if(Helper.hasClass(this.search, 'active')){
        Helper.removeClass(this.search, 'active');
      }
    } else if(entrypoint === 'language'){
      if(Helper.hasClass(this.languageToggler, 'active')){
        Helper.removeClass(this.languageToggler, 'active');
      }
    } else{
      return false;
    }
  }


  bindEsc(target){
    document.addEventListener('keyup', e => {
      if (e.keyCode == 27) {
        document.removeEventListener('keyup', e);
        if(Helper.hasClass(target, 'active')){
          Helper.removeClass(target, 'active');
        }
      }
    });
  }

  setWidth(source, target){
    target.style.width = (source.clientWidth + 1) + 'px';
  }

}
export default Header;
